var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_feather_1 = require("react-feather");
var PaneHeaderButton_styled_1 = require("./PaneHeaderButton_styled");
var PaneHeaderButton = /** @class */ (function (_super) {
    __extends(PaneHeaderButton, _super);
    function PaneHeaderButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOpen = function (e) {
            // prevents setCurrentPane
            e.stopPropagation();
            var _a = _this.props, content = _a.content, setCurrentContent = _a.setCurrentContent;
            setCurrentContent(content.id);
        };
        _this.handleRemove = function (e) {
            // prevents setCurrentPane
            e.stopPropagation();
            var _a = _this.props, content = _a.content, removeContent = _a.removeContent;
            removeContent(content.id);
        };
        return _this;
    }
    PaneHeaderButton.prototype.render = function () {
        var _a = this.props, pane = _a.pane, content = _a.content, contentTypes = _a.contentTypes, removeContent = _a.removeContent;
        var contentType = contentTypes.find(function (ct) { return ct.id === content.type; });
        if (contentType === undefined) {
            throw new Error("unsupported content type: " + content.type + "\n" + JSON.stringify(content));
        }
        var renderContext = { content: content, pane: pane, extra: {
                close: function () { removeContent(content.id); }
            } };
        var label = contentType.renderButton(renderContext);
        var icon = contentType.renderIcon(renderContext);
        return (React.createElement(PaneHeaderButton_styled_1.Container, { isCurrent: content.isCurrent, onClick: this.handleOpen },
            icon,
            React.createElement(PaneHeaderButton_styled_1.Label, null, label),
            React.createElement(PaneHeaderButton_styled_1.RemoveButton, { onClick: this.handleRemove },
                React.createElement(react_feather_1.X, { size: 13 }))));
    };
    return PaneHeaderButton;
}(React.Component));
exports.default = PaneHeaderButton;
